export class SchedulePkModel {
    division: number;
    country: string | null;
    dealer: number;
    advisor: number;
    scheduleHour: number;
    scheduleDate: string;

    constructor(division: number, country: string | null, dealer: number, advisor: number, scheduleHour: number, scheduleDate: string) {
      this.division = division;
      this.country = country;
      this.dealer = dealer;
      this.advisor = advisor;
      this.scheduleHour = scheduleHour;
      this.scheduleDate = scheduleDate;
    }
  }
